<div mat-dialog-content>
    <div  id="content"  style="position: relative; "  class="p-1">
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()" color="primary">{{ 'general.close' | translate }}</button>
    <button mat-button (click)="download()" color="primary">{{ 'general.telecharger' | translate }}</button>
</div>





